<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">

    <data-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="addNewDataSidebar = false" :options="addObj" @ok="addAccount" />
    
    <vs-table ref="table"  :max-items="itemsPerPage" :data="dataTransformed">

      <div slot="header" class="w-full">
       
        <div class="flex flex-wrap-reverse items-center">

          <!-- ADD NEW -->
          <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewDataSidebar = true">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>
          </div>

          <!-- Search -->
          <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-warning border border-solid border-warning" @click="searchPrompt = true">
              <feather-icon icon="SearchIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base">Search</span>
          </div>

          <vs-prompt
            title="Search"
            @cancel="val=''"
            @accept="searchQuery"
            @close="searchPrompt = false"
            :active.sync="searchPrompt">
            <div class="con-exemple-prompt">
              <span>Enter a Phone# or Email to search</span>
            <vs-input @keyup.enter="searchQuery" placeholder="eg. john@company.com,Company Name...." vs-placeholder="eg. john@company.com,416499...." v-model="query" class="mt-3 w-full" />
            </div>
          </vs-prompt>


        </div>

        <div class="flex justify-between py-3 px-4 rounded" style="background:#eee" v-if="searchedTerm">
          <span>
            Showing {{searchResults.length}} results for <b>"{{searchedTerm}}"</b> 
          </span>
          <vs-button size="small" color="warning" @click.native="clearSearch">Clear Search</vs-button>
        </div>

        <!-- ITEMS PER PAGE -->
      
      </div>

      <template slot="thead">
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="category">Email</vs-th>
        <vs-th sort-key="popularity">City</vs-th>
        <!-- <vs-th sort-key="order_status">Confirmed</vs-th> -->
        <!-- <vs-th sort-key="price">Price</vs-th> -->
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

              <vs-td>
                <router-link :to="`/account/${tr.id}`" class="product-name font-medium">{{ tr.name }}</router-link>
              </vs-td>

              <vs-td>
                <p class="product-category">{{ tr.user.email }}</p>
              </vs-td>

              <vs-td>
                {{ tr.city }}
                <!-- <vs-progress :percent="Number(tr.popularity)" :color="getPopularityColor(Number(tr.popularity))" class="shadow-md" /> -->
              </vs-td>

              <!-- <vs-td>
                <vs-chip :color="getOrderStatusColor(tr.user.confirmed)" class="product-order-status">{{ tr.user.confirmed ? 'Yes' : 'No' }}</vs-chip>
              </vs-td> -->

              <!-- <vs-td>
                <p class="product-price">${{ tr.price }}</p>
              </vs-td> -->

            </vs-tr>
          </tbody>
        </template>
    </vs-table>

    <vs-pagination class="mt-3" :total="max" v-model="currentPage"></vs-pagination>
  </div>
</template>

<script>
import DataSidebar from '@/components/DataSidebar.vue';
import {$loading} from '@/assets/helper'
export default {
    sockets: {
        connect: function () {
            console.log('socket connected')
        },
        customEmit: function (data) {
            console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
        }
    },
    components: {
    DataSidebar
    },
    data() {
        return {
            searchPrompt:false,
            query:'',
            currentPage:1,
            totalAccounts:0,
            searchedTerm:'',
            searchResults:[],
            accounts:[],
            addObj:{
                api:'custom',
                apiType:'accounts',
                label:'Client',
                fields:[
                    {
                        label:'Company Name',
                        type:'text',
                        field:'name',
                        required:true
                    },
                    {
                        label:'Email',
                        type:'email',
                        field:'email',
                        required:true
                    },
                    {
                        label:'Address',
                        type:'text',
                        field:'address',
                    },
                    {
                        label:'City',
                        type:'text',
                        field:'city',
                    },
                    {
                        label:'Province',
                        type:'text',
                        field:'region',
                    },
                    {
                        label:'Postal Code',
                        type:'text',
                        field:'zip',
                    },

                ]
            },
            selected: [],
            users: [],
            itemsPerPage: 10,
            isMounted: false,
            addNewDataSidebar: false,
        }
    },
    watch:{
        searchPrompt(){
          this.query = ''
        },
        currentPage:{
            immediate:true,
            async handler(val){
                console.log('STARTINGGGGG ACCOUNTS')
                $loading()
                
                if (!this.totalAccounts){

                    try{
                        let {data} = await this.$get(`/accounts/count`)
                        this.totalAccounts = data    
                    }catch(err){
                        console.error('something happened')
                    }
                    
                }

                let start = this.limit * (val-1) 
                let params = '' 
                if (this.sort) params += `_sort=${this.sort}&`
                if (this.limit) params += `_start=${start}&_limit=${this.limit}`
                let {data} = await this.$get(`/accounts?${params}`)
                this.accounts = data
                $loading.close()
            }
        }
    },
    computed: {
        dataTransformed(){
          if (this.searchedTerm) return this.searchResults 
          return this.accounts
        },
        max(){
            let total = this.totalAccounts
            let limit = this.limit 
            return Math.ceil(total / limit)
        },
        sort(){
            return this.$route.meta.sort || ''
        },
        limit(){
            return this.$route.meta.limit || 10
        },
    },
    methods: {
        clearSearch(){
          this.searchedTerm = '' 
          
        },
        searchQuery(){
          if (!this.query.trim()) return
          $loading()
          let query = this.query
          let url = `/accounts?_where[_or][0][name_contains]=${query}&_where[_or][1][user.email_contains]=${query}`
          this.$get(url).then( ({data}) => {
            this.searchResults = data
            this.searchedTerm = query
          })
          .finally( () => {
            this.searchPrompt = false
            $loading.close()
          })
        },
        addAccount(obj){
            $loading()
            console.log('ADDING ACCOUNT',obj)
            this.$create('/accounts', obj).then( ({data}) => {
              this.addNewDataSidebar = false
              this.$vs.dialog({
                color: 'success',
                title: `Account Created`,
                text: `You have sucessfully created the account: ${data.name}. An email has been dispatched to ${data.user && data.user.email || 'Unknown@email.com'} with login details.`,
                accept: () => this.$router.push(`/account/${data.id}`)
              })
            })
            .finally( () => {
              $loading.close()
            })
        },
    getOrderStatusColor(status) {

        // if(status == 'on hold') return "warning"
        // if(status == 'delivered') return "success"
        if(!status) return "danger"
        return "primary"
    },
    getPopularityColor(num) {
        if(num > 90) return "success"
        if(num >70) return "primary"
        if(num >= 50) return "warning"
        if(num < 50) return "danger"
        return "primary"
    },
    formatData(data) {
        // formats data received from API
        let formattedData = data.map((item) => {
        const fields = item.fields
        let obj = {}
        for (const key of Object.keys(fields)) {
            obj[key] = Number(fields[key].integerValue) || Number(fields[key].doubleValue) || fields[key].stringValue;
        }
        return obj
        });
        return formattedData
    }
    },
    mounted() {
        this.isMounted = true;
    }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
